import { SchemaOf } from 'yup';

import {
  CheckTypeEnum,
  CompanyMonitoringAlertCategoryEnum,
  CompanyMonitoringDataModel,
  CompanyMonitoringVendorEnum,
  EntityTypeEnum,
  PermissionResourceEnum,
  VendorEnum,
} from '../../../shared/models';
import {
  BaseCheckDefinition,
  BaseCheckSettingsDefinition,
} from '../definitions/base-check-definition';
import { FindOptions } from '../definitions/types';
import { CompanyMonitoringCheckInput } from './company-monitoring-check-input';
import { companyMonitoringSettingsSchema } from './validation';

export class CompanyMonitoringCheckDefinition extends BaseCheckDefinition<
  CompanyMonitoringDataModel,
  CompanyMonitoringCheckInput
> {
  // General
  // -------

  get type(): CheckTypeEnum {
    return CheckTypeEnum.company_monitoring;
  }
  get icon(): string {
    // This is a custom icon
    // @see libs/frontend/shared/design-system/src/lib/media-icon/icon/custom/scan-building.ts
    return 'ScanBuilding';
  }
  get checkRelationKey(): 'companyMonitoringData' {
    return 'companyMonitoringData';
  }
  public findOptions(): FindOptions<CompanyMonitoringDataModel> {
    // @TODO - E-3501 - Improve typing of FindOptions
    return {
      relations: ['alerts', 'alerts.review.user'],
      order: {
        createdAt: 'DESC',
        alerts: { createdAt: 'DESC' },
      },
    } as unknown as FindOptions<CompanyMonitoringDataModel>;
  }
  get availableTarget(): EntityTypeEnum[] {
    return [EntityTypeEnum.company];
  }

  get permissionResource(): PermissionResourceEnum {
    return PermissionResourceEnum.check_company_monitoring;
  }

  // Integrations
  // ------------

  get availableVendors(): VendorEnum[] {
    return Object.values(CompanyMonitoringVendorEnum);
  }

  // isInternal
  override get isInternal(): boolean {
    return true;
  }

  // Settings
  // --------

  get settings(): BaseCheckSettingsDefinition<CompanyMonitoringDataModel> {
    return {
      default: {
        alertCategories: Object.values(CompanyMonitoringAlertCategoryEnum),
      },
    };
  }

  // Display
  // -------

  get label(): string {
    return 'Company monitoring';
  }

  // Validation
  // ------

  override get validationSchemas(): {
    settings: SchemaOf<CompanyMonitoringCheckInput['settings']>;
    data?: never;
  } {
    return { settings: companyMonitoringSettingsSchema() };
  }
}

export const companyMonitoringCheckDefinition =
  new CompanyMonitoringCheckDefinition();
